(function() {
'use strict';

angular
    .module('core')
    .factory('maps', maps);

function maps(
    $window,
    $timeout,
    $rootScope,
    $compile,
    $routeParams,
    $q,
    hotelCoordinates,
    hotelRehydrator,
    holidayDeals,
    tripService) {
    const MAX_ZOOM = 1;

    let isMapReady = false;
    let isDealsMode = false;

    return {
        loadScript,
        getLocations,
        buildMap,
        addMarkers
    };

    function loadScript(mapLoadedCb) {
        if (TRPCONFIG.IsBot) { return; }

        // if the script is loading go in polling mode...
        if ($window.EKHMAPS && !isMapReady) {
            return _pollingForMap(mapLoadedCb);
        }

        // ...if script is loaded just callback..
        if ($window.EKHMAPS && isMapReady) {
            return mapLoadedCb();
        }

        // ...actually load the script for maps
        $window.EKHMAPS = _.bind(_mapLoaded, {}, mapLoadedCb);

        const script = `<script type='text/javascript' id='googleScript' src='https://maps.googleapis.com/maps/api/js?key=${TRPCONFIG.Domain.GoogleClientId}&channel=1-Mobile&callback=EKHMAPS'/>`;

        $('head').append(script);
    }

    function _mapLoaded(cb) {
        isMapReady = true;
        cb();
    }

    function _pollingForMap(cb, stop) {
        if (!stop) {
            stop = 0;
        } else if (stop > 10) {
            return cb();
        }

        $timeout(() => {
            if (isMapReady) {
                cb();
            } else {
                _pollingForMap(cb, stop++);
            }
        }, 50);
    }

    function getLocations(position, defaultCoordinates, dealsMode, displayInfoWindow) {
        if (dealsMode) {
            return _getDealsLocations(position);
        }

        let coordinates;
        //Try to get available hotels using the tripId.
        let positions = _getHotelPositionsForTrip().then(data => {
            coordinates = data;
            if (coordinates && coordinates.Hotels && coordinates.Hotels[0]) {
                return coordinates.Hotels;
            }
            //When there are no hotels available then we should make a static call to get all hotels.
            return _getHotelPositionsWithoutTrip();
        });

        if (!positions) {
            positions = $q.when([defaultCoordinates]);
        }

        return positions.then(hps => {
            if (coordinates && coordinates.Destination && coordinates.Destination.EstablishmentId) {
                //When the target establishment is not available, manually inject it into the results.
                let targetHotel = _.find(hps, hp => hp.Id === coordinates.Destination.EstablishmentId);
                if (!targetHotel) {
                    targetHotel = {
                            Id: coordinates.Destination.EstablishmentId,
                            Latitude: coordinates.Destination.Latitude,
                            Longitude: coordinates.Destination.Longitude,
                            isAvailable: false
                    };
                    hps.push(targetHotel);
                }
            }

            return _parseResults(hps, coordinates, defaultCoordinates, displayInfoWindow);
        });
    }

    function _getDealsLocations(position) {
        isDealsMode = true;
        if (position) {
            return $q.when(_parseResults([position]));
        }
        return holidayDeals.getMapCoordinates().then(_parseResults);
    }

    function _parseResults(positions, coordinates, defaultCoordinates, displayInfoWindow) {
        const infoWindow = displayInfoWindow === false ? null : new google.maps.InfoWindow();
        const clickHandler = infoWindow ? _markerClickedFactory(infoWindow, null) : null;

        let result = {
                centre: _getMapCentre(positions, coordinates, defaultCoordinates),
                infoWindow,
                clickHandler,
                markers: [],
                bounds: new google.maps.LatLngBounds()
        };



        if (positions) {
            result.markers = positions.map(hp => {
                const position = new google.maps.LatLng(hp.Latitude, hp.Longitude);
                const m = _createMarker(hp, position, displayInfoWindow);
                result.bounds.extend(position);
                if (result.infoWindow && result.clickHandler) {
                    google.maps.event.addListener(m, 'click', result.clickHandler);
                }
                return m;
            });
        }

        return result;
    }

    function _getHotelPositions(searchId, trip) {
        return hotelCoordinates.getCoordinates(searchId)
            .then(function(data) {
                data = angular.copy(data);
                _.forEach(data.Hotels, h => h.isAvailable = true);
                if (trip) {
                    data.Destination = trip.HotelsRequest.Destination;
                }
                return data;
            });
    }

    function _getHotelPositionsForTrip() {
        if ($routeParams.tripId) {
            return tripService
                .getTrip($routeParams.tripId)
                .then(trip => _getHotelPositions(trip.HotelsRequest.AvailabilitySearchId, trip));
        }
        return $q.when();
    }

    function _getHotelPositionsWithoutTrip() {
        return hotelCoordinates.getCoordinates().then(function(data) {
            data = angular.copy(data);
            let hotels = [];
            if (data && data.Hotels) {
                hotels = data.Hotels;
                _.forEach(hotels, h => {
                    h.isAvailable = false;
                });
            }
            return hotels;
        });
    }

    function _getMapCentre(hotelPositions, hotelCoordinates, defaultCoords) {
        let centre = defaultCoords || { lat: 0, lon: 0 };

        if (hotelPositions && hotelPositions[0]) {
            centre = {
                lat: hotelPositions[0].Latitude,
                lon: hotelPositions[0].Longitude
            };
        } else if (hotelCoordinates && hotelCoordinates.CentrePosition) {
            centre = {
                lat: hotelCoordinates.CentrePosition.Latitude,
                lon: hotelCoordinates.CentrePosition.Longitude
            };
        } else if (hotelCoordinates && hotelCoordinates.Destination) {
            centre = {
                lat: hotelCoordinates.Destination.Latitude,
                lon: hotelCoordinates.Destination.Longitude
            };
        }

        return new google.maps.LatLng(centre.lat, centre.lon);
    }

    function _createMarker(hp, position, displayInfoWindow) {
        return new google.maps.Marker({
            position,
            icon: 'build/img/Maps/map-pin.svg',
            estabId: hp.Id,
            dealMinPrice: hp.DealMinPrice,
            isAvailable: hp.isAvailable,
            clickable: displayInfoWindow
        });
    }

    function _markerClickedFactory(infoWindow, map) {
        return function markerClicked() {
            infoWindow.close();
            infoWindow.setContent('<div class="hotel-info-window-loader"> </div>');

            const hotel = this.isAvailable ? hotelRehydrator.hotel(this.estabId) : hotelRehydrator.staticHotel(this.estabId, true);

            hotel.then(h => {
                infoWindow.open(this.get('map') || map, this);
                const t = '<info-window> </info-window>';
                const s = $rootScope.$new(true);
                if (this.dealMinPrice) {
                    h.MinCost = this.dealMinPrice;
                }
                s.hotel = h;
                s.dealsMode = isDealsMode;
                infoWindow.setContent($compile(t)(s)[0]);
            });
        };
    }

    function buildMap(canvas, center, zoom, selectedMarker, thumbnail) {
        if (thumbnail) {
            this.thumbnail = true;
            return new google.maps.Map(canvas, {
                zoom,
                scrollwheel: false,
                overviewMapControl: false,
                center: selectedMarker ? selectedMarker.getPosition() : center,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                scaleControl: false
            });
        }
        let options = {
            scrollwheel: true,
            overviewMapControl: true,
            center: selectedMarker ? selectedMarker.getPosition() : center,
            mapTypeControl: true,
            streetViewControl: true,
            fullscreenControl: true,
            scaleControl: true
        };
        if (zoom) {
            options.zoom = zoom;
        }
        return new google.maps.Map(canvas, options);
    }

    function addMarkers(map, markers, selectedMarker, infoWindow) {
        if (map.clusterer == null) {
            map.clusterer = new MarkerClusterer(map, markers, { maxZoom: MAX_ZOOM });
        } else if (markers && markers.length) {
            map.clusterer.clearMarkers();
            map.clusterer.addMarkers(markers);
        }

        google.maps.event.addListenerOnce(map, 'idle', () => {
            google.maps.event.trigger(map, 'resize');
            if (selectedMarker && infoWindow) {
                    _markerClickedFactory(infoWindow, map).bind(selectedMarker)();
            }
        });

        return map;
    }
}
})();
